import { useState, useCallback, useEffect } from "react";
import { NavigationPathsEnum } from "@utilities/enums";
import { useNavigation, useUser } from "@utilities/hooks";

export const useControllers = () => {
    const { navigateTo } = useNavigation();

    const { 
        temporaryToken, createPasswordError,
        createuserPasswordSuccess,    
        onCreateUserPassword,
    } = useUser();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [password, setPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [isValidPassword, setIsValidPassword] = useState<boolean>(false);

    useEffect(()=> {
        if(createuserPasswordSuccess){
            navigateTo(NavigationPathsEnum.LOGIN);
        }
    }, [createuserPasswordSuccess, navigateTo]);

    const handleCreatePassword = useCallback(async () => {
        if(isValidPassword && password && confirmPassword){
            if(password === confirmPassword){
                setIsLoading(true);
                await onCreateUserPassword(temporaryToken, password);
                setIsLoading(false);
            }
        }
    }, [
        confirmPassword, isValidPassword, 
        password, temporaryToken,
        onCreateUserPassword,
    ]);

    return {
        password,
        confirmPassword,
        isLoading,
        createPasswordError,
        isValidPassword, setIsValidPassword,
        setPassword,
        setConfirmPassword,
        handleCreatePassword,
    };
};
